exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pt5 {\n  padding-top: 5px;\n}\n.ui.input .react-datepicker-wrapper .react-datepicker__input-container input[type='text'].transaction-summary--date-picker {\n  width: 100%;\n}\n.pt10 {\n  padding-top: 10px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/inventory/transaction/transactionSummary/index.less
// module id = 3668
// module chunks = 0